/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";
import { AutoclaveEquipmentsDetail } from "../../../../postAutoclaveProcess/emptySterilization/emptySterilization.types";
import { SterilizationDetails } from "../../../types/mediaBatchCommon.types";

interface Props {
	autoclaveEquipments: AutoclaveEquipmentsDetail[];
	selectedAutoclaveEq: AutoclaveEquipmentsDetail | null;
	handleAutoclaveChange: (id: string) => void;
	sterilizationDetails?: SterilizationDetails;
	isReadOnly: boolean;
	errors: {
		autoclave: string;
	};
	setErrors: React.Dispatch<React.SetStateAction<any>>;
}

const MBSAutoclaveSelection = ({ autoclaveEquipments, selectedAutoclaveEq, handleAutoclaveChange, sterilizationDetails, isReadOnly, errors, setErrors }: Props) => {
	const { t } = useTranslation();
	return (
		<div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
			<div className="px-6 py-2 border-b border-slate-100 flex items-center gap-2">
				<div className="w-6 h-6 rounded-md bg-[#2D3E50] text-white flex items-center justify-center text-[10px] font-black">
					01
				</div>
				<h3 className="text-[10px] font-black text-[#2D3E50] uppercase tracking-widest mt-2">
					{t("mediaBatchInit.sterilization.autoclaveSelection")}
				</h3>
			</div>
			<div className="p-6 grid grid-cols-2 gap-8">
				<div className="space-y-2">
					<label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block">
						{t("mediaBatchInit.sterilization.selectUnit")} <span className="text-red-500">*</span>
					</label>
					<div className="relative">
						<select
							value={isReadOnly ? "view-autoclave" : (selectedAutoclaveEq?.id ?? "")}
							disabled={isReadOnly}
							className={`w-full pl-4 pr-10 py-2.5 border border-slate-200 rounded-lg text-xs font-bold text-slate-700 outline-none appearance-none ${
								isReadOnly
									? "bg-slate-100 opacity-70 cursor-not-allowed"
									: "bg-slate-50/50"
							}`}
							onChange={(e) => {
								handleAutoclaveChange(e.target.value);
								setErrors((prev: any) => ({ ...prev, autoclave: "" }));
							}}
						>
							{isReadOnly ? (
								<option value="view-autoclave">
									{sterilizationDetails?.autoclave_name}
								</option>
							) : (
								<>
									<option value="" disabled>
										{t("mediaBatchInit.preparation.selectBatch")}
									</option>

									{autoclaveEquipments.map((eq) => (
										<option key={eq.id} value={eq.id}>
											{eq.name}
										</option>
									))}
								</>
							)}
						</select>
						<span className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-slate-300">
							expand_more
						</span>
						{!isReadOnly && errors.autoclave && (<p className="text-red-500 text-[11px] mt-1">{errors.autoclave}</p>)}
					</div>
					<div className="flex items-center gap-2 text-[8px] font-bold text-emerald-500 uppercase">
						<span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
							{t("mediaBatchInit.sterilization.operationalStatus")}: Ready
					</div>
				</div>
			</div>
		</div>
	);
};

export default MBSAutoclaveSelection;
